import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Message, Segment } from 'semantic-ui-react';
import groupBy from 'lodash.groupby';
import orderBy from 'lodash.orderby';
import styles from './Wallets.module.scss';
import Wallet from './Wallet';
import AddWalletModal from './AddWalletModal';

const Wallets = ({ wallets, actions, policies, payment, userEmailAddress, userId }) => {
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [addOpen, setAddOpen] = useState(false);

	const load = useCallback(async () => {
		setLoading(true);
		try {
			setError(false);
			await actions.getPaymentWallets(policies.length ? policies.map((p) => p.policyNumber) : []);
		} catch(error) {
			console.log(error)
			setError(true);
		}
		setLoading(false);
	}, [actions, policies]);

	useEffect(() => {
		load();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const _wallets = useMemo(() => {
		let groups = groupBy(wallets, 'walletId');
		groups = Object.keys(groups).map((key) => {
			const groupedItems = groups[key];
			const firstWallet = groupedItems.length > 0 ? groupedItems[0] : {};

			return {
				walletId: key,
				consumerName: firstWallet.consumerName,
				consumerEmail: firstWallet.consumerEmail,
				consumerPhone: firstWallet.consumerPhone,
				keyIdentifier: firstWallet.walletKeyIdentifier,
				isPolicy: /[A-Z]{3}\d{7}/.test(firstWallet.walletKeyIdentifier) || /RCC_[A-Z]{3}\d{7}/.test(firstWallet.walletKeyIdentifier),
				wallets: groups[key],
			};
		});

		groups = orderBy(groups, 'isPolicy');

		return groups;
	}, [wallets]);

	const onChange = useCallback(() => {
		setAddOpen(false);
		load();
	}, [load]);

	const colors = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];

	if (loading) return null;

	return (
		<div>
			{error && <Message error>Failed to load wallet</Message>}
			{!error && (
				<React.Fragment>
					<div className={styles.header}>
						<AddWalletModal open={addOpen} onOpen={() => setAddOpen(true)} onClose={() => setAddOpen(false)} onAdd={onChange} actions={actions} payment={payment} userEmailAddress={userEmailAddress} userId={userId} />
					</div>

					{_wallets.length === 0 && (
						<Segment style={{ textAlign: 'center' }}>
							<h2>No Wallets</h2>
						</Segment>
					)}

					{_wallets.map((wallet, i) => {
						return <Wallet key={i} wallet={wallet} color={colors[i % colors.length]} actions={actions} payment={payment} userEmailAddress={userEmailAddress} onChange={onChange} />;
					})}
				</React.Fragment>
			)}
		</div>
	);
};

Wallets.propTypes = {
	payment: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	policies: PropTypes.array.isRequired,
	userEmailAddress: PropTypes.string.isRequired,
};

export default Wallets;
